import React from 'react';
export const NoRecord = ({ onClearFilter, hideClearFilter }) => {
  return (
    <div class="b2b-lib-noresult">
      <div class="b2b-lib-resultcontent">
        <h2>No Result Found!</h2>
        <p>We couldn’t find what you are looking for.</p>
        {!hideClearFilter && (
          <div class="b2b-lib-btnresult">
            <div class="b2b-lib-transparentbtn" onClick={onClearFilter}>
              Clear Filter
            </div>
          </div>
        )}
      </div>
      <div className="image-container">
        <img alt="No Record" src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/no-result.svg" />
      </div>
    </div>
  );
};
